import {
	FormImageUploaderNewContext,
	IFormImageUploaderNewContext,
	IMaxFileSizeMB,
} from '../../formImageUploaderNewState/formImageUploaderNewContext';
import React, { useContext, useCallback, useMemo } from 'react';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import classNames from 'classnames';
import style from './ErrorModals.module.scss';

interface IProps {
	maxFileSizeMB: IMaxFileSizeMB;
}

export const ErrorModals: React.FC<IProps> = ({ maxFileSizeMB }) => {
	const { changeTypeOfErrorModalWindow, typeOfErrorModalWindow } =
		useContext<IFormImageUploaderNewContext>(FormImageUploaderNewContext);
	const containerClasses = classNames(style.container, { [style.visible]: typeOfErrorModalWindow });

	const maxImageFileSize = useMemo(() => ({ size: `${maxFileSizeMB.img}MB` }), [maxFileSizeMB]);
	const maxGifFileSize = useMemo(() => ({ size: `${maxFileSizeMB.gif}MB` }), [maxFileSizeMB]);
	const maxVideoFileSize = useMemo(() => ({ size: `${maxFileSizeMB.video}MB` }), [maxFileSizeMB]);
	const imageFormats = useMemo(() => ({ formats: '.jpeg, .jpg, .png' }), []);
	const gifFormats = useMemo(() => ({ formats: '.gif' }), []);
	const videoFormats = useMemo(() => ({ format: '.mp4' }), []);

	const handleCloseModal = useCallback(() => {
		changeTypeOfErrorModalWindow(null);
	}, []);

	return (
		<div className={containerClasses} data-test="ModalWindows">
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfErrorModalWindow === 'fileSizeExceeded'}
				description="fileSizeExceeded"
				translationOptions={maxImageFileSize}
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfErrorModalWindow === 'gifFileSizeExceeded'}
				description="fileSizeExceeded"
				translationOptions={maxGifFileSize}
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfErrorModalWindow === 'fileUploadError'}
				description="fileUploadError"
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfErrorModalWindow === 'invalidFileFormat'}
				description="invalidFileFormatPhoto"
				translationOptions={imageFormats}
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfErrorModalWindow === 'invalidGifFormat'}
				description="invalidFileFormatGif"
				translationOptions={gifFormats}
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfErrorModalWindow === 'videoFileSizeExceeded'}
				description="fileSizeExceeded"
				translationOptions={maxVideoFileSize}
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfErrorModalWindow === 'invalidVideoFormat'}
				description="invalidFileFormat"
				translationOptions={videoFormats}
			/>
		</div>
	);
};
